import { useCallback } from 'react';
import { Epoch } from '../types/epochs';
import { getEpochYears, isOngoing } from '../utils/epochUtils';

export const useEpochCalculations = (epochs: Epoch[], epochHeights: { [key: string]: number }) => {
  const calculateVerticalPosition = useCallback((index: number) => {
    const VERTICAL_GAP = .925;
    const MIN_EPOCH_HEIGHT = 1.5;
    let position = 0;

    for (let i = 0; i < index; i++) {
      const prevEpochHeight = Math.max(
        epochHeights[epochs[i].title] || MIN_EPOCH_HEIGHT,
        MIN_EPOCH_HEIGHT
      );
      position += prevEpochHeight + VERTICAL_GAP;
    }

    return position;
  }, [epochs, epochHeights]);

  const calculatePositions = useCallback((startYear: number, endYear: number) => {
    const years = epochs.flatMap(epoch => getEpochYears(epoch));
    const uniqueYears = years.filter((year, index) => years.indexOf(year) === index)
      .sort((a, b) => a - b);
    const totalWidth = uniqueYears.length - 1;

    const startIndex = uniqueYears.indexOf(startYear);
    
    // For ongoing epochs, use the last available year index
    let endIndex = uniqueYears.indexOf(endYear);
    if (endIndex === -1 && endYear >= Math.max(...uniqueYears)) {
      endIndex = uniqueYears.length - 1;
    }

    const startPosition = Number(((startIndex / totalWidth) * 100).toFixed(3)) - 0.1;
    const width = Number((((endIndex - startIndex) / totalWidth) * 100).toFixed(3)) + 0.2;

    return { startPosition, width };
  }, [epochs]);

  return { calculateVerticalPosition, calculatePositions };
}; 